import { Calendar } from 'primereact/calendar'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1600px;
    margin: auto;
    padding: 0 20px;
    margin-top: 1rem;
    margin-bottom: 5rem;

    @media (max-width: 768px) {
        width: 100%;
        padding: 0 5px;
    }
`

export const ScannerWrapper = styled.div`
    width: 100%;
    max-width: 500px;
    height: auto;
    max-height: calc(100vh - 80px);
    aspect-ratio: 1;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        max-width: 100%;
    }
`

export const ScannerContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    border: 3px solid #ba9d31;
    border-radius: 16px;
    overflow: hidden;
    background: #000;

    /* Force html5-qrcode injected elements to fill the container */
    & > div {
        width: 100% !important;
        height: 100% !important;
        padding: 0 !important;
    }

    & video {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        border-radius: 16px;
    }

    /* Remove the scan region overlay */
    & #qr-shaded-region {
        display: none !important;
    }
`

export const Corner = styled.div<{ position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' }>`
    position: absolute;
    z-index: 100;
    width: 30px;
    height: 30px;
    border: 4px solid #ba9d31;
    border-radius: 0;

    ${({ position }) =>
        position === 'top-left' &&
        `
    top: 25%;
    left: 25%;
    border-right: none;
    border-bottom: none;
  `}
    ${({ position }) =>
        position === 'top-right' &&
        `
    top: 25%;
    right: 25%;
    border-left: none;
    border-bottom: none;
  `}
  ${({ position }) =>
        position === 'bottom-left' &&
        `
    bottom: 25%;
    left: 25%;
    border-right: none;
    border-top: none;
  `}
  ${({ position }) =>
        position === 'bottom-right' &&
        `
    bottom: 25%;
    right: 25%;
    border-left: none;
    border-top: none;
  `}
`

export const StyledCalendar = styled(Calendar)`
    .p-button {
        background: #ba9d31;
    }
`

export const Title = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 500;
    margin-top: 1rem;
`

export const TicketDataLabel = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 500;
    margin: 0;
`
